import React from "react";
import {ButtonGroup, LinkButton} from "../ui/spectre/buttons";
import translate from "../../../translate";
import {Icon} from "../ui/spectre/icon";
import {GroupMembershipCard} from "./groupMembershipCard";

export default function OwnGroupsList({ memberships }) {
    return <div>
        <div className={'btn-group'}>
            <ButtonGroup>
                <LinkButton href={'/groups/create'}>
                    <div className={'d-inline-block mr-2'}>
                        <Icon type={'plus'} />
                    </div>
                    {translate('page/groups/create_group')}
                </LinkButton>
                <LinkButton href={'/groups/join'}>
                    <div className={'d-inline-block mr-2'}>
                        <Icon type={'people'} />
                    </div>
                    {translate('page/groups/join_group')}
                </LinkButton>
            </ButtonGroup>
        </div>

        <div className={'group-list-container mt-2'}>
            {Object.values(memberships).map(membership => <GroupMembershipCard membership={membership} key={membership.id} />)}
        </div>
    </div>;
}
